import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton
} from '@mui/material';
import React from 'react';

function Row(props) {
  const { row, handlePreview, handleDelete } = props;

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="center">{row.filename}</TableCell>
        <TableCell align="center">{row.attachment_type_display}</TableCell>

        <TableCell>
          <IconButton
            onClick={() => handlePreview(row.id)} // Call handlePreview
            color="primary"
          >
            <RemoveRedEyeIcon />
          </IconButton>
        </TableCell>
        <TableCell>
          <IconButton
            onClick={() => handleDelete(row)} // Call handleDelete
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const PositionsList = ({ formik, handlePreview, handleDelete }) => {
  const handleDeleteee = () => {
    console.log('x');
    console.log('y');
  };
  // const handleDelete = async () => {
  //   if (position !== null) {
  //     if (module !== 'zielone_szkoly') {
  //       formik.setFieldValue('positions', formik.values.positions.filter(p => p.id !== position.id));
  //     } else {
  //       const { error } = await mutate(position.id);
  //       if (!error) {
  //         dispatch(updateOrder({ ...order, products: positions.filter(p => p.id !== position.id) }));
  //         setPosition(null);
  //         toast.success('Pozycja została usunięta');
  //       } else {
  //         toast.error('Wystąpił błąd');
  //       }
  //     }
  //   }
  // };

  return (
    <Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Nazwa pliku</TableCell>
            <TableCell align="center">Typ dokumentu</TableCell>
            <TableCell align="center">Akcje</TableCell>
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {formik.values.attachments.map((position, index) => (
            <Row
              key={index}
              row={position}
              handlePreview={handlePreview}
              handleDelete={handleDelete} // Pass handleDelete
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default PositionsList;
